import { omit } from 'lodash';

import { conditionalArray } from 'utils/arrays';

export const PROGRAMS_PAGE_SLUG = 'programs';
export const PLATFORM_PROGRAMS_PAGE_SLUG = 'platform-programs';
export const PLACEMENT_HISTORY_PAGE_SLUG = 'placement-history';
export const FORM_RESPONSES_PAGE_SLUG = 'form-analytics-placement-view';
export const FORM_RESPONSES_FORM_VIEW_PAGE_SLUG = 'form-analytics-form-view';
export const TIMESHEET_PROGRESS_PAGE_SLUG = 'timesheet-progress';
export const BASE_URL = '/program-management/';

export const CANDIDATES_PAGE_SLUG = 'candidates';
export const OPPORTUNITIES_PAGE_SLUG = 'opportunities';
export const PLACEMENTS_PAGE_SLUG = 'placements';

export const OPPORTUNITIES_LIST_SLUG = 'industry-partner-opportunities';
export const CANDIDATES_LIST_SLUG = 'industry-partner-candidates';
export const ORG_CANDIDATES_LIST_SLUG = 'org-industry-partner-candidates';
export const PLACEMENTS_LIST_SLUG = 'industry-partner-placements';

export const FORMS = 'forms';
export const DOCUMENTS = 'documents';
export const APPLICATIONS = 'applications';
export const TIMESHEETS = 'timesheets';
export const EVALUATIONS = 'evaluations';
export const COMMENTS = 'comments';

export const TABS = ({ hasEvaluation, isBYOP }) => [
  { order: 0, tab: 'Forms', key: FORMS },
  // ...conditionalArray(!isOrganization, [
  //   { order: 1, tab: 'Files', key: DOCUMENTS },
  // ]),
  ...conditionalArray(!isBYOP, [
    {
      order: 1,
      tab: 'Applications',
      key: APPLICATIONS,
    },
  ]),
  { order: 2, tab: 'Timesheet', key: TIMESHEETS },
  ...conditionalArray(hasEvaluation, [
    { order: 3, tab: 'Evaluation', key: EVALUATIONS },
  ]),
  { order: 4, tab: 'Comments & activity', key: COMMENTS },
];

export const STUDENT_SCOPE_STRING = 'studentScope';
export const ALUMNI_SCOPE_STRING = 'alumniScope';

export const PM_GROUP_ID = 1;
export const CANDIDATE_GROUP_ID = 2;
export const SPONSOR_GROUP_ID = 3;
export const GUARDIAN_GROUP_ID = 4;

export const PROGRAM_MANAGER_STRING = 'program manager';

export const USER_TYPE_LABEL = Object.freeze({
  [PM_GROUP_ID]: 'Your form',
  [CANDIDATE_GROUP_ID]: 'Candidate',
  [SPONSOR_GROUP_ID]: 'Sponsor',
  [GUARDIAN_GROUP_ID]: 'Guardian',
});

export const FORM_ANALYTICS_LABEL = Object.freeze({
  [PM_GROUP_ID]: 'Program mangers',
  [CANDIDATE_GROUP_ID]: 'Candidates',
  [SPONSOR_GROUP_ID]: 'Sponsors',
  [GUARDIAN_GROUP_ID]: 'Guardians',
});

export const RESPONSIBLE_PARTY_LABEL_TO_ID = Object.freeze({
  programManager: PM_GROUP_ID,
  candidate: CANDIDATE_GROUP_ID,
  sponsor: SPONSOR_GROUP_ID,
  guardian: GUARDIAN_GROUP_ID,
});

export const RESPONSIBLE_PARTY_ID_TO_LABEL = Object.freeze({
  [PM_GROUP_ID]: 'programManager',
  [CANDIDATE_GROUP_ID]: 'candidate',
  [SPONSOR_GROUP_ID]: 'sponsor',
  [GUARDIAN_GROUP_ID]: 'guardian',
});

export const SURVEY_TAB_STATUS = Object.freeze({
  ACTION: {
    color: 'red',
    text: 'Action required',
  },
  AWAITING: {
    color: 'orange',
    text: 'Waiting for responses',
  },
  COMPLETED: {
    color: 'green',
    text: 'completed',
  },
});

export const FIELD_TYPES = {
  SINGLE_SELECT: 'single_select',
  MULTI_SELECT: 'multi_select',
  FREE_RESPONSE: 'free_response',
  FREE_RESPONSE_MULTILINE: 'free_response_multiline',
  BOOLEAN: 'boolean',
  FILE: 'file',
  DATE: 'date',
  ADDRESS: 'address',
  SPONSOR: 'sponsor',
};

export const FIELD_TYPE_HUMAN_READABLE_LABEL = {
  single_select: 'Single answer',
  multi_select: 'Multiple-choice',
  free_response: 'Single line answer',
  free_response_multiline: 'Multi line answer',
  boolean: 'Yes/No',
  file: 'File upload',
  date: 'Date',
  address: 'Address',
  sponsor: 'Sponsor',
};

export const SPONSOR = 'sponsor';
export const CANDIDATE = 'candidate';
export const OPPORTUNITY = 'opportunity';

export const APP_QUESTION_CUSTOM_FIELD_KEY = 'custom';
export const CAREER_CLUSTER_FIELD_KEY = 'default.career_cluster';

export const FIRST_NAME_FIELD_KEY = 'first_name';
export const LAST_NAME_FIELD_KEY = 'last_name';
export const EMAIL_FIELD_KEY = 'email';

export const STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS = {
  SPONSOR: 'opportunity.affiliation',
  NUM_OF_POSITIONS: 'opportunity.slot_count',
  OPPORTUNITY_NAME: 'opportunity.name',
  OPPORTUNITY_DESCRIPTION: 'opportunity.description',
  OPPORTUNITY_LOCATION: 'opportunity.location_types',
  OPPORTUNITY_ADDRESS: 'opportunity.address',
  CAREER_CLUSTER: 'default.career_cluster',
};

export const BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS = {
  SPONSOR_FIRST_NAME: `${SPONSOR}.${FIRST_NAME_FIELD_KEY}`,
  SPONSOR_LAST_NAME: `${SPONSOR}.${LAST_NAME_FIELD_KEY}`,
  SPONSOR_EMAIL: `${SPONSOR}.${EMAIL_FIELD_KEY}`,
  JOB_TITLE: 'sponsor.position_title',
  OPPORTUNITY_NAME: 'opportunity.name',
  OPPORTUNITY_DESCRIPTION: 'opportunity.description',
  PHONE_NUMBER: 'sponsor.phone',
  ORGANIZATION: 'sponsor.organization_name',
  ORGANIZATION_ADDRESS: 'sponsor.business_address',
};

export const BYOP_APP_QUESTION_RESPONSIBLE_PARTY = {
  CANDIDATE_ONLY: 'candidate_only',
  SPONSOR_ONLY: 'sponsor_only',
  SPONSOR_READ_ONLY: 'sponsor_r',
  SPONSOR_READ_WRITE: 'sponsor_rw',
};

export const BYOP_APP_QUESTION_RESPONSIBLE_PARTY_LABEL = {
  [BYOP_APP_QUESTION_RESPONSIBLE_PARTY.SPONSOR_ONLY]: 'Sponsor',
  [BYOP_APP_QUESTION_RESPONSIBLE_PARTY.CANDIDATE_ONLY]: 'Candidate only',
  [BYOP_APP_QUESTION_RESPONSIBLE_PARTY.SPONSOR_READ_ONLY]:
    'Sponsor can view only',
  [BYOP_APP_QUESTION_RESPONSIBLE_PARTY.SPONSOR_READ_WRITE]:
    'Sponsor can also edit',
};

export const BYOP_SPONSOR_SECTION = {
  value: SPONSOR,
  label: 'Sponsor information',
};

export const BYOP_OPPORTUNITY_SECTION = {
  value: OPPORTUNITY,
  label: 'Opportunity details',
};

export const BYOP_CANDIDATE_SECTION = {
  value: CANDIDATE,
  label: 'Candidate questions',
};

export const BYOP_APP_SECTIONS = [
  BYOP_SPONSOR_SECTION,
  BYOP_OPPORTUNITY_SECTION,
  BYOP_CANDIDATE_SECTION,
];

export const STAFF_MANAGED_QUESTIONS_UNEDITABLE = [
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.NUM_OF_POSITIONS,
];

export const STAFF_MANAGED_QUESTIONS_SPONSOR_PHRASING_CANNOT_BE_EDITED = [
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.NUM_OF_POSITIONS,
];

export const STAFF_MANAGED_SPONSOR_ONLY_QUESTIONS = [
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.NUM_OF_POSITIONS,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_NAME,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_DESCRIPTION,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_LOCATION,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_ADDRESS,
];

export const STAFF_MANAGED_QUESTIONS_CANNOT_BE_OPTIONAL = [
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_NAME,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.NUM_OF_POSITIONS,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_DESCRIPTION,
];

export const STAFF_MANAGED_QUESTIONS_CANNOT_BE_HIDDEN = [
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_NAME,
  STAFF_MANAGED_DEFAULT_APP_QUESTION_FIELD_KEYS.NUM_OF_POSITIONS,
];

export const BYOP_QUESTIONS_UNEDITABLE = [
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_FIRST_NAME,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_LAST_NAME,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_EMAIL,
];

export const BYOP_QUESTIONS_CANNOT_BE_HIDDEN_OR_OPTIONAL = [
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_FIRST_NAME,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_LAST_NAME,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_EMAIL,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.ORGANIZATION,
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.OPPORTUNITY_NAME,
];

/* cspell:disable-next-line */
export const BYOP_QUESTIONS_CANNOT_BE_RESECTIONED = [
  BYOP_DEFAULT_APP_QUESTION_FIELD_KEYS.SPONSOR_EMAIL,
];

export const STAFF_FACING_ONLY_TOOLTIP =
  'This question will not be shown to candidates and sponsors because it is marked staff-facing only';

export const DELETE_TOOLTIP = 'delete';
export const EDIT_TOOLTIP = 'edit';

export const K12_CONFIG_GUIDE =
  'https://s3.amazonaws.com/assets.schoolinks.com/assets/misc/IPPM_config_guide.pdf';
export const ORG_CONFIG_GUIDE =
  'https://s3.amazonaws.com/assets.schoolinks.com/assets/misc/IPPM_config_guide_org.pdf';

export const PROGRAM_MANAGERS = 'programManagers';
export const PLACEMENT_MANAGERS = 'placementManagers';

export const PROGRAM_MANAGER = 'program_manager';
export const PLACEMENT_MANAGER = 'placement_manager';

export const ADDED = 'added';
export const REMOVED = 'removed';

export const PROGRAM_MODE_STAFF_MANAGED = 'staff-managed-placement';
export const PROGRAM_MODE_STUDENT_SOURCED = 'student-sourced-placement';

export const METHOD_STUDENT_SOURCED = 'student_sourced';
export const METHOD_STAFF_MANAGED = 'staff_managed';

export const PENDING_SPONSOR_ACCEPTANCE = 'pending_sponsor_acceptance';

export const STUDENT_SOURCED_STATUSES = {
  complete: {
    color: 'green',
    text: 'APPROVED',
  },
  pending_pm_approval: {
    color: 'orange',
    text: 'PENDING',
  },
  pending_sponsor_acceptance: {
    color: 'orange',
    text: 'PENDING',
  },
  sponsor_invite_bounced: {
    color: 'red',
    text: 'INVITE FAILED',
  },
  pending_submission: {
    color: 'yellow',
    text: 'NOT SUBMITTED',
  },
};

const sharedButtonProps = {
  variant: 'outlined',
  modal: 'APPROVE_BYOP_MODAL',
  style: {
    width: '100%',
    justifyContent: 'center',
  },
};

export const STUDENT_SOURCED_STATUSES_PM = {
  complete: {
    color: 'green',
    text: 'APPROVED',
  },
  pending_pm_approval: {
    color: 'orange',
    text: 'NOT APPROVED',
    buttonProps: {
      ...sharedButtonProps,
      label: 'Approve placement',
      variant: 'filled',
    },
  },
  pending_sponsor_acceptance: {
    color: 'blue-steel',
    text: 'SPONSOR PENDING',
    buttonProps: {
      ...sharedButtonProps,
      label: 'Accept on behalf',
      modal: 'APPROVE_BYOP_MODAL',
    },
  },
  sponsor_invite_bounced: {
    color: 'red',
    text: 'INVITE FAILED',
    buttonProps: {
      ...sharedButtonProps,
      label: 'Update sponsor email',
    },
  },
  pending_submission: {
    color: 'yellow',
    text: 'NOT SUBMITTED',
    buttonProps: {
      ...omit(sharedButtonProps, 'variant'),
      label: 'View progress',
      variant: 'text',
    },
  },
  published: {
    color: 'green',
    text: 'PUBLISHED',
  },
  published_for_candidate: {
    color: 'yellow',
    text: 'PUBLISHED FOR CANDIDATE',
    buttonProps: {
      ...omit(sharedButtonProps, 'modal'),
      label: 'Publish for sponsor',
      variant: 'outlined',
    },
  },
  published_for_sponsor: {
    color: 'yellow',
    text: 'PUBLISHED FOR SPONSOR',
    buttonProps: {
      ...omit(sharedButtonProps, 'modal'),
      label: 'Publish for candidate',
      variant: 'outlined',
    },
  },
  not_published: {
    color: 'orange',
    text: 'NOT PUBLISHED',
    buttonProps: {
      ...omit(sharedButtonProps, 'modal'),
      label: 'Publish',
      variant: 'filled',
    },
  },
};

// Submitted
export const HEATMAP_COMPLETED = 'complete';
// Inactive
export const HEATMAP_INACTIVE = 'inactive';
// Active and not submitted yet
export const HEATMAP_INCOMPLETE = 'incomplete';
// Active, not submitted, beyond due date
export const HEATMAP_OVERDUE = 'overdue';
// Active, not submitted, blocked because a previous step in sequence is overdue
export const HEATMAP_BLOCKED = 'blocked';

export const BYOP_TEXT_KEY = 'byopText';

export const STAFF_MANAGED_SPONSOR_PHRASING_KEY = 'sponsorPhrasing';

export const STAFF_MANAGED_CANDIDATE_PHRASING_KEY = 'candidatePhrasing';

export const EMPLOYER = 'Employer';

export const DECLINED = 'declined';
export const SUBMITTED = 'submitted';
export const ACCEPTED = 'accepted';

export const FORM_SEQUENCES_EXPORT = 'formSequencesExport';

// Placement manager access types
export const ACCESS_TYPE_PROGRAM_WIDE = 'program_wide';
export const ACCESS_TYPE_STUDENT_SCOPE = 'student_scope';
export const ACCESS_TYPE_STAFF_ROSTERS = 'staff_roster';
export const ACCESS_TYPE_SYNCED_ROSTERS = 'synced_staff_roster';
export const ACCESS_TYPE_SELECTED_ROSTERS = 'specific_staff_roster';

export const ACCESS_TYPE_LABELS = {
  [ACCESS_TYPE_PROGRAM_WIDE]: 'Program-wide',
  [ACCESS_TYPE_STUDENT_SCOPE]: 'Student scope',
  [ACCESS_TYPE_STAFF_ROSTERS]: 'Staff rosters',
  [ACCESS_TYPE_SYNCED_ROSTERS]: 'Synced rosters',
  [ACCESS_TYPE_SELECTED_ROSTERS]: 'Selected rosters',
};

export const USER_FIELD = 'user';
export const ROLE_FIELD = 'role';
export const SCOPE_FIELD = 'scope';
export const CASELOADS_FIELD = 'caseloads';

export const ORGANIZATION = 'organization';
export const DISTRICT = 'district';

export const ADDED_BY_STAFF_SOURCE = 'added_by_staff';

export const IPPM_CANDIDATE_TABLE_ID = 'industry-partner-candidates';
export const IPPM_OPPORTUNITY_TABLE_ID = 'industry-partner-opportunities';
export const IPPM_PLACEMENT_TABLE_ID = 'industry-partner-placements';
